import * as React from 'react';

import user from 'js/lib/user';

import 'css!bundles/enterprise-legacy-learner-home/components/__styles__/DefaultUserLogo';

type Props = {
  size?: number;
};

const DefaultUserLogo = ({ size = 32 }: Props) => {
  let lastInitial;
  const currentUser = user.get();
  const fullNameArray = (currentUser.fullName ?? '').split(' ');

  // @ts-expect-error TS2488 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  const [[firstInitial]] = fullNameArray;

  if (fullNameArray.length > 1) {
    [lastInitial] = fullNameArray[fullNameArray.length - 1];
  }

  return (
    <div className="rc-DefaultUserLogo" style={{ width: `${size}px`, height: `${size}px` }}>
      {firstInitial && <span>{firstInitial}</span>}
      {lastInitial && <span>{lastInitial}</span>}
    </div>
  );
};

export default DefaultUserLogo;
